import { CourseIndex, CourseStatus, CourseViewModel } from "../../model/Course";
import { ApiResponse } from "../CustomFetch";
import { api, transformApiResponse } from "./BaseApi";

const courseApi = api.enhanceEndpoints({ addTagTypes: ["Courses"] }).injectEndpoints({
  endpoints: (builder) => ({
    getCourses: builder.query<CourseIndex[], void>({
      query: () => "course",
      transformResponse: transformApiResponse,
      providesTags: [{ type: "Courses", id: "LIST" }],
    }),

    getCourse: builder.query<CourseViewModel, string>({
      query: (courseId) => `course/${courseId}`,
      transformResponse: transformApiResponse,
      providesTags: (_result, _error, arg) => [{ type: "Courses", id: arg }],
    }),

    createCourse: builder.mutation<ApiResponse<string>, CourseViewModel>({
      query: (courseViewModel) => ({
        url: `course`,
        body: courseViewModel,
        method: "POST",
      }),
      invalidatesTags: [{ type: "Courses", id: "LIST" }],
    }),

    updateCourse: builder.mutation<ApiResponse<void>, CourseViewModel>({
      query: (courseViewModel) => ({
        url: `course`,
        body: courseViewModel,
        method: "PUT",
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: "Courses", id: "LIST" },
        { type: "Courses", id: arg.id },
      ],
    }),

    publishCourse: builder.mutation<ApiResponse<void>, CourseViewModel>({
      query: (courseViewModel) => ({
        url: `course/status/${courseViewModel.id}/${CourseStatus.Published}`,
        body: courseViewModel,
        method: "PUT",
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: "Courses", id: "LIST" },
        { type: "Courses", id: arg.id },
      ],
    }),

    archiveCourse: builder.mutation<ApiResponse<void>, CourseViewModel>({
      query: (courseViewModel) => ({
        url: `course/status/${courseViewModel.id}/${CourseStatus.Archived}`,
        body: courseViewModel,
        method: "PUT",
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: "Courses", id: "LIST" },
        { type: "Courses", id: arg.id },
      ],
    }),

    deleteCourse: builder.mutation<ApiResponse<void>, string>({
      query: (courseId) => ({
        url: `course/${courseId}`,
        method: "DELETE",
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: "Courses", id: "LIST" },
        { type: "Courses", id: arg },
      ],
    }),
  }),
});

export const {
  useGetCoursesQuery,
  useGetCourseQuery,
  useCreateCourseMutation,
  useUpdateCourseMutation,
  usePublishCourseMutation,
  useArchiveCourseMutation,
  useDeleteCourseMutation,
} = courseApi;
